module.exports = __webpack_public_path__ + "static/media/sub-modal-1.8abec860.jpg";